module.exports = __webpack_public_path__ + "static/media/streaming.23da3396.svg";